import React, { useState, useEffect } from "react";
import { Typography, Button, Box, Divider } from "@mui/material";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import ReportToolbar from "../ReportToolbar";
import ReportFooter from "../ReportFooter";
import axios from "axios";
import { APIURL } from "../../../config";
import moment from "moment";

export default function PA_UtilizationReport(props) {
    const columns = [
        {
            field: "DDDID",
            headerName: "DDD ID",
            width: 100,
        },
        {
            field: "PatientName",
            headerName: "Patient Name",
            width: 150,
        },
        {
            field: "DateOfBirth",
            headerName: "DOB",
            width: 125,
        },
        {
            field: "memberMedicaid",
            headerName: "Medicaid ID",
            width: 150,
        },
        {
            field: "priorAuth",
            headerName: "Prior Auth",
            width: 125,
        },
        {
            field: "procCode",
            headerName: "Proc Code",
            width: 125,
        },
        {
            field: "DiagnosisCode",
            headerName: "Diagnosis Code",
            width: 125,
        },
        {
            field: "AuthUnits",
            headerName: "Auth Units",
            width: 125,
        },
        {
            field: "AuthAmount",
            headerName: "Auth Amount",
            width: 125,
        },
        {
            field: "ClaimStatus",
            headerName: "Claim Status",
            width: 125,
        },
    ];

    const rows = props.data.preAuth.map((claim, index) => {
        const claimDets = {
            id: index,
            DDDID: claim.DDDID[0] ? claim.DDDID[0] : '',
            PatientName: claim.cus_name,
            DateOfBirth: claim.dob ? moment(claim.dob).format('MM/DD/YYYY') : '',
            memberMedicaid: claim.memberMedicaid,
            priorAuth: claim.priorAuth,
            procCode: claim.procedureCode,
            DiagnosisCode: '',
            AuthUnits: claim.authUnits,
            AuthAmount: claim.authAmount,
        };
        return claimDets;
    });

    const totalRow = {
        id: 'total-row',
        DDDID: '',
        PatientName: '',
        DateOfBirth: '',
        memberMedicaid: '',
        priorAuth: '',
        procCode: '',
        DiagnosisCode: 'TOTAL:',
        AuthUnits: props.data.unitTotal,
        AuthAmount: props.data.amountTotal,
        ClaimStatus: '',
        isTotal: true,
    };

    const CustomToolbar = () => {
        const pieData = [
            { name: 'Amount Not Matched', value: Number(props.data.totAmountNotMatched) },
            { name: 'Amount Paid', value: Number(props.data.totAmountPaid) },
            { name: 'Amount Pending', value: Number(props.data.totAmountPending) },
            { name: 'Amount Approved but not Billed', value: Number(props.data.totAmountApprovedButNotBilled) },
        ];

        const COLORS = ['#00C49F', '#FFBB28', '#FF8042', '#FF6384'];

        const isAllZero = (data) => data.every(item => item.value === 0);

        return (
            <ReportToolbar companyName={props.user.company_name} reportTitle="Utilization Report">
                <Box sx={{ pl: 1, pr: 1 }}>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Date Range: {props.data.from} - {props.data.to}</div>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ marginLeft: "20px" }}>
                        <p style={{ color: 'grey', textDecoration: 'underline', margin: 0 }}>Expected Revenue:</p>
                        <p style={{}}>${props.data.expectedRevenue}</p>
                    </div>

                    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />

                    <div style={{ display: "flex", justifyContent: 'space-between' }}>
                        <div style={{ marginRight: "30px" }}>
                            <p style={{ color: 'grey', textDecoration: 'underline', margin: 0 }}>Pre Auth charges:</p>
                            <p style={{}}>${props.data.totAuthAmount}</p>

                            <p style={{ color: 'grey', textDecoration: 'underline', margin: 0 }}>Charges matched:</p>
                            <p style={{}}>${props.data.totAmountMatched}</p>

                            <p style={{ color: 'grey', textDecoration: 'underline', margin: 0 }}>MT approved:</p>
                            <p style={{}}>${props.data.totAmountApproved}</p>
                        </div>

                        <div style={{ marginRight: "30px" }}>
                            <p style={{ color: 'grey', textDecoration: 'underline', margin: 0 }}>Other charges:</p>
                            <p style={{}}>${props.data.totOtherAmount}</p>

                            <p style={{ color: 'grey', textDecoration: 'underline', margin: 0 }}>Charges unmatched:</p>
                            <p style={{}}>${props.data.totAmountNotMatched}</p>

                            <p style={{ color: 'grey', textDecoration: 'underline', margin: 0 }}>MT billed:</p>
                            <p style={{}}>${props.data.totAmountBilled}</p>
                        </div>

                        <div style={{ marginRight: "30px" }}>
                            <p style={{ color: "#FFFFFF" }}>.</p>
                            <p style={{ color: "#FFFFFF" }}>.</p>
                            <p style={{ color: "#FFFFFF", margin: 1 }}>.</p>
                            <p style={{ color: "#FFFFFF", margin: 1 }}>.</p>

                            <p style={{ color: 'grey', textDecoration: 'underline', margin: 0 }}>MT paid:</p>
                            <p style={{}}>${props.data.totAmountPaid}</p>
                        </div>
                    </div>

                    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />

                    <div style={{}}>
                        <PieChart width={550} height={250}>
                            {isAllZero(pieData) ? (
                                <>
                                    <circle
                                        cx="225"
                                        cy="125"
                                        r="120"
                                        fill="none"
                                        stroke="#8884d8"
                                        strokeWidth="2"
                                        strokeDasharray="5,5"
                                    />
                                    <text x="225" y="125" textAnchor="middle" dominantBaseline="middle" fill='#8884d8'>
                                        No data to display
                                    </text>
                                </>
                            ) : (
                                <Pie
                                    data={pieData}
                                    cx={225}
                                    cy={125}
                                    labelLine={false}
                                    outerRadius={120}
                                    fill="#8884d8"
                                    dataKey="value"
                                >
                                    {pieData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                            )}
                            <Tooltip />
                        </PieChart>
                    </div>
                </Box>
            </ReportToolbar>
        );
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ height: '80vh' }}>
                <DataGridPro
                    initialState={{ sorting: { sortModel: [{ field: "Service_Date", sort: "desc" }] } }}
                    getRowId={(row) => row.id}
                    rows={rows}
                    columns={columns}
                    slots={{
                        toolbar: CustomToolbar,
                        footer: ReportFooter
                    }}
                    pinnedRows={{ bottom: [totalRow] }}
                    getRowClassName={(params) => {
                        return params.row.isTotal ? 'total-row' : '';
                    }}
                    sx={{
                        '& .total-row': {
                            backgroundColor: '#f5f5f5',
                            fontWeight: 'bold',
                            borderTop: '2px solid #ddd',
                            '&:hover': {
                                backgroundColor: '#f0f0f0',
                            }
                        }
                    }}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    disableVirtualization
                    showToolbar
                />
            </div>
        </div>
    );
}